import React, { FC, useState, Fragment, useEffect } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { Form, Input, Button, Row, Col, Spin, notification } from "antd";
import { PasswordInput } from "@components/password-input";

import Layout from "@layout/auth";

import "./reset-password.scss";

import Link from "@components/link";
import { routeMap } from "@utils/constants";
import { VALIDATION } from "@utils/messages";
import authService from "@services/auth.service";
import { useLocation, useParams } from "react-router-dom";
import { get } from "@utils/axios";
import { IClient } from "../login";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { getPasswordSecret } from "@utils/helpers";
var CryptoJS = require("crypto-js");

const initialValues = {
  password: "",
  confirmPassword: "",
};

const errorMessages = {
  required: VALIDATION.required,
  types: {
    email: VALIDATION.email,
  },
};

const ResetPassword: FC<any> = () => {
  const [form] = Form.useForm();
  const [credentials, setCredentials] = useState(initialValues);
  const [success, setSuccess] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [match, setMatch] = useState<any>({});
  const [token, setToken] = useState<string>();
  const [domains, setDomains] = useState<IClient[]>([]);
  const [domainId, setDomainId] = useState<string>("");
  const [isInValid, setIsInValid] = useState<boolean>(false);
  const location = useLocation();
  let pathParam = useParams();

  useEffect(() => {
    console.log("ResetPassword.useEffect1");
    if (pathParam && pathParam?.token && pathParam?.domain_id) {
      setToken(pathParam.token);
      setDomainId(pathParam?.domain_id);
    }
  }, [location.search, pathParam]);

  useEffect(() => {
    console.log("ResetPassword.useEffect2");
    fetchDomains();
    appInsights.trackPageView({ name: "Reset Password" });
  }, []);

  /**
   * Function to fetch all domains/clients app url from database
   */
  const fetchDomains = async () => {
    console.log("ResetPassword.fetchDomains");
    get(`${process.env.REACT_APP_API_BASE_URI}/domain/domains`).subscribe({
      next: (v: any) => {
        let domains = []
        try {
          let response = v?.data?.data?.domains
          let domainsD = CryptoJS.AES.decrypt(
            response,
            getPasswordSecret()
          );
          let decryptedDomains = domainsD.toString(CryptoJS.enc.Utf8);
          domains = JSON.parse(
            decryptedDomains
          )
        } catch (e) {
          console.log(e)
          domains = []
        }
        
        const domainsData = domains?.map((d: any) => {
          return {
            clientName: d.client_name,
            domainName: d.user_domain_name,
            appServiceUrl: d.app_service_url,
            domain_id: d.domain_id,
          };
        });

        let tempSelectOptions: any[] = [];
        let pushedClientsMap: any[] = [];
        domainsData.forEach((d: any) => {
          if (!pushedClientsMap.includes(d.clientName)) {
            tempSelectOptions.push(d);
            pushedClientsMap.push(d.clientName);
          }
        });

        setDomains(domainsData);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const rules: any = {
    length: 10,
    uppercase: 1,
    symbols: ["%", "$", "^", "@", "#"],
    lowercase: 1,
    number: 1,
  };

  function onValueChange(changes: any, values: any) {
    setCredentials(values);
  }

  function onFieldsChange(changes: any, values: any) {
    setIsInValid(form.getFieldsError().some((field) => field.errors.length > 0));
  }

  function onChange(e: any, matches: any) {
    setMatch(matches);
  }

  function onSubmit() {
    // find the domain of the backend
    console.log(domains);
    const client = domains.find((c) => {
      console.log(c, domainId);
      return parseInt(c.domain_id) === parseInt(domainId);
    });

    console.log(client);

    if (client) {
      setLoader(true);
      authService.healthCheck(client).subscribe({
        next: (v) => {
          authService.resetPassword(credentials.password, credentials.confirmPassword, token, client).subscribe({
            next: (v) => {
              setLoader(false);
              setSuccess(true);
            },
            error: (e) => {
              setLoader(false);
              setSuccess(false);
            },
          });
        },
        error: (e) => {
          console.log(e);
          setLoader(false);
          setSuccess(false);
          notification.error({
            message: "Error",
            description: "Backend services are not accessible/available. Please check if you are connected to VPN, if applicable, otherwise please contact your IT Admin",
          });
        },
      });
    }

    console.log(credentials);
  }

  return (
    <Layout>
      <Row>
        <Col span={14} className="m-auto">
          <div className="auth-reset-password">
            {success ? (
              <div className="done">
                <div className="ico">
                  <span className="check-circle"></span>
                </div>
                <h1 className="clr-s100 f32 w600 successText">
                  Password has been <br /> reset successfully!
                </h1>
                <p className="f16 clr-darkTextColor">
                  Please <Link text="Login" className="w500" link={routeMap.login} /> to continue.
                </p>
              </div>
            ) : (
              <Fragment>
                <Link
                  text={
                    <span>
                      <i className="icon-arrow-left clr-p100"></i> Back to Login
                    </span>
                  }
                  link={routeMap.login}
                  className="w500"
                />

                <h1 className="w700">Reset Password</h1>

                <Form
                  name="loginForm"
                  className="form"
                  layout="vertical"
                  form={form}
                  initialValues={initialValues}
                  validateMessages={errorMessages}
                  onValuesChange={onValueChange}
                  onFieldsChange={onFieldsChange}
                  onFinish={onSubmit}
                >
                  <Form.Item
                    label="New Password"
                    name="password"
                    className="fr"
                    rules={[
                      { required: true },
                      {
                        pattern: new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[%$^@#]).{10,}$"),
                        message: "Password must be at least 10 characters long, contain an uppercase letter, a number, and a special character",
                      },
                    ]}
                  >
                    <PasswordInput
                      label="Password Strenght:"
                      onChange={onChange}
                      rules={rules}
                      inputProps={{
                        size: "large",
                        placeholder: "Enter password",
                      }}
                    />
                  </Form.Item>
                  <div className="password-info">
                    <p className="f16 w500 clr-n100">Password must contain</p>
                    <p className="clr-n75 password-rules">
                      <span className={`${match.length ? "clr-s100" : ""}`}>min of 10 characters</span>
                      <span>, </span>
                      <span className={`${match.lowercase ? "clr-s100" : ""}`}>atleast 1 lowercase</span>
                      <span>, </span>
                      <span className={`${match.uppercase ? "clr-s100" : ""}`}>atleast 1 UPPERCASE</span>
                      <span>, </span>
                      <span className={`${match.number ? "clr-s100" : ""}`}>atleast 1 number</span>
                      <span> and </span>
                      <span className={`${match.symbols ? "clr-s100" : ""}`}>1 symbol out of these %$^@#</span>
                    </p>
                  </div>

                  <Form.Item
                    label="Confirm new password"
                    name="confirmPassword"
                    className="fr"
                    dependencies={["password"]}
                    rules={[
                      { required: true },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(VALIDATION.match));
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Confirm new password" size="large" />
                  </Form.Item>

                  <Spin spinning={loader} indicator={<HealthemSpinner />}>
                    <Button size="large" type="primary" htmlType="submit" block disabled={!form.isFieldsTouched() || isInValid}>
                      Reset Password
                    </Button>
                  </Spin>
                  <div className="fr">
                    <p className="tc clr-n75">Contact your Admin for help</p>
                  </div>
                </Form>
              </Fragment>
            )}
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default withAITracking(reactPlugin, ResetPassword);
